import type {AttachmentResource} from '~/lib/types/uploads';
import {resolveRieAttachment} from '~/composables/uploads/useUpload';
import {saveBlob} from '~/lib/download';

export const downloadAttachment = async (attachments: AttachmentResource[], id: string) => {
	if (!attachments) {
		throw new Error('No attachments supplied.');
	}

	const attachment = attachments.find((attachment) => {
		return attachment.upload.uploadId === id;
	});

	if (!attachment) {
		throw new Error(`Attachment with id ${id} not found.`);
	}

	const {response, data} = await resolveRieAttachment(attachment.id);
	if (!response.ok || !data) {
		throw new Error(`Failed to download attachment with id ${id}.`);
	}

	saveBlob(data, attachment.upload.filename);
};
